export default class ElectroElCommand {
  constructor(el, data, funcUpdatePrice, funcCheckSide, app) {
    this.el = el;
    this.data = data;
    this.funcUpdatePrice = funcUpdatePrice;
    this.app = app;
    this.funcCheckSide = funcCheckSide;
  }
  execute() {
    this.el.toggleElectro(this.el, this.data.next, this.data.prev);
    if (this.app.current) {
      this.funcCheckSide(this.app.current);
    } else {
      this.funcCheckSide(undefined);
    }
    this.funcUpdatePrice();
  }

  undo() {
    this.el.toggleElectro(this.el, this.data.prev, this.data.next);
    if (this.app.current) {
      this.funcCheckSide(this.app.current);
    } else {
      this.funcCheckSide(undefined);
    }
    this.funcUpdatePrice();
  }
}
